module.exports = ":host .links{display:flex;justify-content:space-between}:host .form-group:last-of-type{margin-bottom:3rem}\n"